import { Alert, Col, Form, Radio, Row } from "antd";
import React from "react";
import "./StepsOrg.scss";
import { radioButton } from "../../../../utils/rules";

export default function SolicitaDocOrg(props) {
    const { getFieldDecorator, onChangeRadio, observaciones, disabled } = props;

    return (
        <>
        <Row gutter={20}>
            <Col span={12}>
                <h4>Soporte documental</h4>
                <Alert message="No se cargó el soporte documental." type="info" showIcon />
            </Col>
            <Col span={12}>
                <h4>Datos capturados</h4>
                <div className="datosCapturados">
                    <Row>
                        <Col span={24} className="paddingDatos">
                            <Form.Item label="¿Deseas solicitar que se cargue el soporte documental?" 
                                style={{fontWeight: "bold"}}
                            >
                                {getFieldDecorator("solicitaDoc", {
                                    rules: radioButton,
                                    initialValue: observaciones.solicitaDoc,
                                })(
                                    <Radio.Group onChange={onChangeRadio("solicitaDoc")} style={{fontWeight: "normal"}}
                                        disabled={disabled.solicitaDoc}
                                    >
                                        <Radio value={true}>Sí</Radio>
                                        <Radio value={false}>No</Radio>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
        </>
    );

}